var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorfulStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 19,
    viewBox: "0 0 102 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25988 0L11.7092 5.76812L18.0666 6.26735L13.2229 10.3315L14.7027 16.4081L9.25988 13.1518L3.81706 16.4081L5.29688 10.3315L0.453211 6.26735L6.81061 5.76812L9.25988 0Z",
    fill: "#B03F6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0958 0L32.5451 5.76812L38.9025 6.26735L34.0588 10.3315L35.5386 16.4081L30.0958 13.1518L24.653 16.4081L26.1328 10.3315L21.2891 6.26735L27.6465 5.76812L30.0958 0Z",
    fill: "#B03F6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9288 0L53.3781 5.76812L59.7355 6.26735L54.8918 10.3315L56.3716 16.4081L50.9288 13.1518L45.486 16.4081L46.9658 10.3315L42.1222 6.26735L48.4796 5.76812L50.9288 0Z",
    fill: "#B03F6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7648 0L74.214 5.76812L80.5714 6.26735L75.7278 10.3315L77.2076 16.4081L71.7648 13.1518L66.3219 16.4081L67.8018 10.3315L62.9581 6.26735L69.3155 5.76812L71.7648 0Z",
    fill: "#B03F6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5987 0L95.048 5.76812L101.405 6.26735L96.5617 10.3315L98.0416 16.4081L92.5987 13.1518L87.1559 16.4081L88.6357 10.3315L83.7921 6.26735L90.1495 5.76812L92.5987 0Z",
    fill: "#B03F6E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulStars);
export default __webpack_public_path__ + "static/media/colorfulStars.c9e2dd1410092bafcd76b3d11f1bb1e8.svg";
export { ForwardRef as ReactComponent };